import React from 'react'
import { LabelContent } from './LabelContent'
import { Label, SwitchBox } from 'procyon-ui'
import { getHTMLDataTestID } from 'infra/utils'

const SwitchBoxLabelContent = ({ editMode, value = false, label, onChange }) => {
  return (
    <LabelContent
      content={
        <div
          data-testid={getHTMLDataTestID('switch', 'input', 'toggle')}
        >
          {editMode && (
            <SwitchBox
              label={value ? 'Enabled' : 'Disabled'}
              onChange={(_, c) => onChange(c)}
              checked={value}
            />
          )}
          {!editMode &&
            (value ? (
              <Label text='Enabled' variant='success' />
            ) : (
              <Label text='Disabled' variant='gray' />
            ))}
        </div>
      }
      title={label}
    />
  )
}

export { SwitchBoxLabelContent }
